import { Redirect } from 'react-router-dom';
import { InlineStatus } from 'components/InlineStatus';
import { useGeoEvent } from 'features/geoEvents/hooks/useGeoEvent';
import {
  isFloodingGeoEvent,
  isHazardGeoEvent,
  isLocationGeoEvent,
  isWildfireGeoEvent,
} from 'features/geoEvents/geoEvent.utils';
import { AnyGeoEvent } from 'features/geoEvents/anyGeoEvent.types';
import { useSelectedIncidentGeoEventId } from 'features/geoEvents/hooks/useSelectedIncidentGeoEventId';
import { WildfireDetails } from 'pages/WildfireDetails';
import { FloodingDetails } from 'pages/FloodingDetails';
import { PageNotFound } from 'app/pages/PageNotFound';
import { HazardDetails } from '../../app/pages/Home/HazardContent/HazardDetails';

export const GeoEventDetails = (): JSX.Element => {
  const geoEventId = useSelectedIncidentGeoEventId();
  const { geoEvent, isGeoEventLoading, isGeoEventFetchError } =
    useGeoEvent<AnyGeoEvent>({
      id: geoEventId,
      useCacheBuster: true,
    });

  if (isGeoEventLoading || isGeoEventFetchError || !geoEvent) {
    return <InlineStatus status={isGeoEventLoading ? 'loading' : 'error'} />;
  }

  if (isWildfireGeoEvent(geoEvent)) {
    return <WildfireDetails />;
  }

  if (isFloodingGeoEvent(geoEvent)) {
    return <FloodingDetails />;
  }

  if (isHazardGeoEvent(geoEvent)) {
    return <HazardDetails />;
  }

  if (isLocationGeoEvent(geoEvent)) {
    return <Redirect to={`/location/${geoEventId}`} />;
  }

  return <PageNotFound />;
};
